import { render, staticRenderFns } from "./SlideNumber.vue?vue&type=template&id=45d8daf5&"
import script from "./SlideNumber.vue?vue&type=script&lang=js&"
export * from "./SlideNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports